import React from 'react';
import { Grid, InputLabel } from '@material-ui/core';
import { useQuery } from '@apollo/client';
import { GET_USER_BY_ID } from '../../queries/user';
import useStyles from './styles';

const GetUser = (userId) => useQuery(GET_USER_BY_ID, {
  variables: { id: userId },
});

export const CreatedBy = ({ createdBy }) => {
  const createdByQuery = GetUser(createdBy);
  const classes = useStyles();

  return (
    <Grid item xs={12}>
      <InputLabel shrink color="primary" className={classes.textField}>
        Created by
      </InputLabel>
      {createdByQuery.data && createdByQuery.data.user.name}
    </Grid>
  );
};
